export class LoanConformingLimitsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanLimits(body) {
    return this.#http.post('/api/loan-conforming-limits', body);
  }
}
